import { Eyebrow, Grid, LinkCard, Stack, Text } from "@generalapplications/ui";

import {
  RevealGroup,
  RevealItem,
} from "@/app/common/components/composite/motion/RevealGroup";
import type { IndustrySlug } from "@/content/industries";
import { routes } from "@/app/common/functions/routes/routes";

export type IndustryGroupProps = {
  label: string;
  industries: readonly { label: string; slug: IndustrySlug }[];
};

/** A labelled set of industries, each a tile into its own page. */
export function IndustryGroup({ label, industries }: IndustryGroupProps) {
  return (
    <Stack gap="sm">
      <Eyebrow tone="muted">{label}</Eyebrow>
      <RevealGroup>
        <Grid as="ul" columns={{ base: 1, sm: 2, lg: 3 }} gap="sm">
          {industries.map((industry) => (
            <RevealItem key={industry.slug} as="li">
              <LinkCard href={routes.industries.detail(industry.slug)}>
                <Text as="span" variant="label" weight="bold" align="center">
                  {industry.label}
                </Text>
              </LinkCard>
            </RevealItem>
          ))}
        </Grid>
      </RevealGroup>
    </Stack>
  );
}
